// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_R3Xhg","listWrap":"index_listWrap_SX0Xc","tloader":"index_tloader_Sm7sb","tloaderBody":"index_tloaderBody_Nk20t"};